import * as React from 'react'
import s from './vertical-divider.scss'

export const VerticalDivider = () => <div className={s.verticalDivider} />
